import lottie from 'lottie-web';
import { config } from '@js/state';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.gameUIAssetsLoad();
    this.loadRemainingGameSceneAssets();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.stop('LoadScene');
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    this.load.audio('backgroundMusic', 'assets/audio/backgroundMusic.mp3');
    this.load.audio('confettiSound', 'assets/audio/confetti.wav');
    this.load.audio('yay', 'assets/audio/yay.wav');
    this.load.audio('correctSound', 'assets/audio/correctSound.mp3');
    this.load.audio('incorrectSound', 'assets/audio/incorrectSound.mp3');
    this.load.audio('newQuestion', 'assets/audio/newQuestion.mp3');
    this.load.audio('reward_reveal', 'assets/audio/reward_reveal.mp3');
    this.load.audio('hintaudio', 'assets/audio/Hint Alert.mp3');

    this.load.atlas(
      'JiggiWaveAnim',
      'assets/anims/JiggiWaveAnim/jiggiWaveAnim-0.png',
      'assets/anims/JiggiWaveAnim/jiggiWaveAnim.json',
    );

    this.load.image('startBackground', 'assets/StartSceneAssets/startBackground.png');
    this.load.image('playButton', 'assets/StartSceneAssets/playButton.png');
    this.load.image('hover_playButton', 'assets/StartSceneAssets/hover_playButton.png');
    this.load.image('startPodium', 'assets/StartSceneAssets/startPodium.png');

    this.load.image('gameBackground', 'assets/GameSceneAssets/gameBackground.png');
    this.load.image('podium', 'assets/GameSceneAssets/podium.png');

    this.load.image('yellowLight', 'assets/GameSceneAssets/yellowLight.png');
    this.load.image('redLight', 'assets/GameSceneAssets/redLight.png');
    this.load.image('greenLight', 'assets/GameSceneAssets/greenLight.png');

    this.load.image('qnImage1', 'assets/GameSceneAssets/qnImage1.png');

    this.load.atlas(
      'hintFinalAnim',
      'assets/anims/hintFinalAnim.png',
      'assets/anims/hintFinalAnim.json',
    );

    this.load.image('cardMask', 'assets/GameSceneAssets/cardMask.png');

    this.load.image('cardHolder', 'assets/GameSceneAssets/cardHolder.png');
    this.load.image('correctCard', 'assets/GameSceneAssets/correctCard.png');
    this.load.image('wrongCard', 'assets/GameSceneAssets/wrongCard.png');
    this.load.image('defaultCard', 'assets/GameSceneAssets/defaultCard.png');

    this.load.image('spotlight', 'assets/GameSceneAssets/spotlight.png');

    this.load.image('closeHint', 'assets/GameSceneAssets/closeHintIconhdpi.png');
    this.load.image('overlay', 'assets/GameSceneAssets/overlay.png');

    this.load.multiatlas(
      'confetti',
      'assets/anims/VerticalConfettiAnim.json',
      'assets/anims',
    );
    this.load.image('tutText1', 'assets/TutorialSceneAssets/tutText1.png');
    this.load.image('tutText2', 'assets/TutorialSceneAssets/tutText2.png');
    this.load.image('tutText3', 'assets/TutorialSceneAssets/tutText3.png');
    this.load.image('tutText4', 'assets/TutorialSceneAssets/tutText4.png');
    this.load.image('selectionStroke', 'assets/TutorialSceneAssets/selectionStroke.png');
  }

  gameUIAssetsLoad() {
    this.load.image('q', 'assets/uiAssets/q.png');

    this.load.image('hint', 'assets/uiAssets/Hint.png');
    this.load.image('closeHint', 'assets/uiAssets/closeHintIconhdpi.png');

    this.load.image('mask', 'assets/uiAssets/mask.png');
    this.load.image('progressBar', 'assets/uiAssets/progressBar.png');
    this.load.image('holder', 'assets/uiAssets/holder.png');
    this.load.image('settings', 'assets/uiAssets/settings.png');
    this.load.image('yellow', 'assets/uiAssets/yellow.png');
    this.load.image('circle', 'assets/uiAssets/circle.png');
    this.load.image('dropDown', 'assets/uiAssets/dropDown.png');
    this.load.image('fullScreenOff', 'assets/uiAssets/fullScreenOff.png');
    this.load.image('fullScreen', 'assets/uiAssets/fullScreen.png');
    this.load.image('sound', 'assets/uiAssets/sound.png');
    this.load.image('mute', 'assets/uiAssets/mute.png');
    this.load.image('paused', 'assets/uiAssets/paused.png');

    this.load.multiatlas(
      'playAnim',
      'assets/uiAssets/Game UI Anims/Tera Animations/playPauseAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraIn',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraAppearAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraIdle',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraIdleBlinkAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraCorrect',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraCorrectAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraWrong',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraWrongAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraThink',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraThinkAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraIdea',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraIdeaAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
    this.load.multiatlas(
      'teraOut',
      'assets/uiAssets/Game UI Anims/Tera Animations/teraOutAnim.json',
      'assets/uiAssets/Game UI Anims/Tera Animations',
    );
  }

  loadRemainingGameSceneAssets() {
    this.load.image('qnImage2', 'assets/GameSceneAssets/qnImage2.png');
    this.load.image('qnImage3', 'assets/GameSceneAssets/qnImage3.png');
    this.load.image('qnImage4', 'assets/GameSceneAssets/qnImage4.png');
    this.load.image('qnImage5', 'assets/GameSceneAssets/qnImage5.png');
    this.load.image('qnImage6', 'assets/GameSceneAssets/qnImage6.png');
    this.load.image('qnImage7', 'assets/GameSceneAssets/qnImage7.png');
    this.load.image('qnImage8', 'assets/GameSceneAssets/qnImage8.png');
    this.load.image('qnImage9', 'assets/GameSceneAssets/qnImage9.png');
    this.load.image('qnImage10', 'assets/GameSceneAssets/qnImage10.png');
    this.load.image('qnImageTut', 'assets/GameSceneAssets/qnImageTut.png');

    this.load.image('hintStyle1', 'assets/GameSceneAssets/hintImages/hintStyle1.png');
    this.load.image('hintStyle2', 'assets/GameSceneAssets/hintImages/hintStyle2.png');
    this.load.image('hintStyle3', 'assets/GameSceneAssets/hintImages/hintStyle3.png');
    this.load.image('hintStyle4', 'assets/GameSceneAssets/hintImages/hintStyle4.png');
    this.load.image('hintStyle5', 'assets/GameSceneAssets/hintImages/hintStyle5.png');
    this.load.image('hintStyle7', 'assets/GameSceneAssets/hintImages/hintStyle7.png');
    this.load.image('hintStyle9', 'assets/GameSceneAssets/hintImages/hintStyle9.png');
    this.load.image('hintStyle10', 'assets/GameSceneAssets/hintImages/hintStyle10.png');
    this.load.image('hintStyle12', 'assets/GameSceneAssets/hintImages/hintStyle12.png');
  }

  update() {}
}
